module.exports = __webpack_public_path__ + "media/images/icons/expand-up-6fee4fb01d73ea740b8f26b422cb8161.svg";